<template>
    <div>
        <section class="content">
            <div class="row">
                <div class="box box-info">
                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="info-box">
                                    <ul class="timeline">
                                        <!-- timeline time label -->
                                        <li class="time-label">
                                            <span class="bg-green">Instructivo del Portal</span>
                                        </li>
                                        <li>
                                            <div class="timeline-item col-md-10">
                                                <div class="timeline-body ">
                                                    <div class="col-md-12 ">
                                                        <div class="col-md-12 ">
                                                          <div class="col-md-12 ">
                                                            <div class="col-md-12 ">
                                                              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-for="manual in manualsInstructive">
                                                                  <a style="color: #FFF" :href="manual.path" target="_blank" class="progress-description">
                                                                      <div class="info-box" style="background-color: #909090">
                                                                          <span class="info-box-icon" style=""><i class="fa fa-book"></i></span>
                                                                          <div class="info-box-content" style="max-height: 90px">
                                                                              <span class="info-box-number" style="white-space: pre-line; text-overflow: ellipsis">{{manual.name}}</span>
                                                                          </div>
                                                                      </div>
                                                                  </a>
                                                              </div>
                                                              <!--
                                                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                                  <a style="color: #FFF" :href="manuals[0].path" target="_blank" class="progress-description">
                                                                      <div class="info-box" style="background-color: #909090">
                                                                          <span class="info-box-icon" style=""><i class="fa fa-book"></i></span>
                                                                          <div class="info-box-content" style="max-height: 90px">
                                                                              <span class="info-box-number" style="white-space: pre-line; text-overflow: ellipsis">Instructivo 1</span>
                                                                              <h4>Ver</h4>
                                                                          </div>
                                                                      </div>
                                                                  </a>
                                                                </div>
                                                              -->
                                                            </div>
                                                          </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="time-label">
                                            <span class="bg-red">Normas y Procedimientos para Proveedores</span>
                                        </li>
                                        <li>
                                            <div class="timeline-item col-md-10">
                                                <div class="timeline-body ">
                                                    <div class="col-md-12 ">
                                                        <div class="col-md-12 ">
                                                          <div class="col-md-12 ">
                                                              <div class="col-md-12 ">
                                                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" v-for="manual in manualsNorms">
                                                                    <a style="color: #FFF" :href="manual.path" target="_blank" class="progress-description">
                                                                    <div class="info-box" style="background-color: #909090">
                                                                      <span class="info-box-icon" style=""><i class="fa fa-book"></i></span>
                                                                      <div class="info-box-content" style="max-height: 90px">
                                                                        <span class="info-box-number" style="white-space: pre-line; text-overflow: ellipsis">{{manual.name}}</span>
                                                                      </div>
                                                                    </div>
                                                                    </a>
                                                                </div>
                                                              </div>
                                                          </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
require('moment')
import datepicker from 'vue-date-picker'
import api from '../../api'
import {timeline} from '../../demo'
import { mapState } from 'vuex'

export default {
  name: 'Settings',
  components: {
    datepicker
  },
  data (router) {
    return {
      section: 'ChangePsw',
      loading: '',
      manuals: [],
      manualsInstructive: [],
      manualsNorms: []
    }
  },
  computed: {
    datetime () {
      return new Date()
    },
    ...mapState([
      'userInfo', 'user'
    ]),
    timeline () {
      return timeline
    }
    // bussinesdata () {
      // var datos = {cuit: 369852147, address: 'Mi Direccion 1234', billingAddress: 'Mi otra dirección 4567'}
      // return datos
    // }
  },
  mounted () {
    this.getManual()
  },
  methods: {
    getManual (row) {
      api.request('get', 'api/generic/manual')
      .then(response => {
        if (Array.isArray(response.data)) {
          this.manuals = response.data
        }
        this.manualsInstructive = this.manuals.filter(el => el.category === '0')
        this.manualsNorms = this.manuals.filter(el => el.category === '1')
      })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>

/*
 * Component: Timeline
 * -------------------
 */
.timeline {
  position: relative;
  margin: 0 0 30px 0;
  padding: 0;
  list-style: none;
}
.timeline:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #ddd;
  left: 31px;
  margin: 0;
  border-radius: 2px;
}
.timeline > li {
  position: relative;
  margin-right: 10px;
  margin-bottom: 15px;
}
.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table;
}
.timeline > li:after {
  clear: both;
}
.timeline > li > .timeline-item {
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  margin-top: 0;
  background: #fff;
  color: #444;
  margin-left: 60px;
  margin-right: 15px;
  padding: 0;
  position: relative;
}
.timeline > li > .timeline-item > .time {
  color: #999;
  float: right;
  padding: 10px;
  font-size: 12px;
}
.timeline > li > .timeline-item > .timeline-header {
  margin: 0;
  color: #555;
  border-bottom: 1px solid #f4f4f4;
  padding: 10px;
  font-size: 16px;
  line-height: 1.1;
}
.timeline > li > .timeline-item > .timeline-header > a {
  font-weight: 600;
}
.timeline > li > .timeline-item > .timeline-body,
.timeline > li > .timeline-item > .timeline-footer {
  padding: 10px;
}
.timeline > li > .fa,
.timeline > li > .glyphicon,
.timeline > li > .ion {
  width: 30px;
  height: 30px;
  font-size: 15px;
  line-height: 30px;
  position: absolute;
  color: #666;
  background: #d2d6de;
  border-radius: 50%;
  text-align: center;
  left: 18px;
  top: 0;
}
.timeline > .time-label > span {
  font-weight: 600;
  padding: 5px;
  display: inline-block;
  background-color: #fff;
  border-radius: 4px;
}
.timeline-inverse > li > .timeline-item {
  background: #f0f0f0;
  border: 1px solid #ddd;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.timeline-inverse > li > .timeline-item > .timeline-header {
  border-bottom-color: #ddd;
}
.datetime-picker input {
  height: 4em !important;
}
.row  {
  padding-bottom: 1em;
}

.fondo {
  background-color: #EDEEEE;
}

.fondo_danger {
  background-color: #F0E0D0;
}


.boton {
  padding: 1em;
}
textarea { 
 resize: none;
}




</style>



// WEBPACK FOOTER //
// Manuals.vue?07fd7daa